<template>
    <div
        class="alert alert-secondary border-left-lg border-left-secondary rounded-lg py-2 px-3 m-1 mb-2 shadow-sm d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center my-1">
            <div class="bg-primary text-white rounded-circle mr-3 d-flex align-items-center justify-content-center shadow-sm"
                style="width: 40px; height: 40px; min-width: 40px;">
                <i class="fas fa-baby fa-lg"></i>
            </div>
            <div>
                <div class="text-xs font-weight-bold text-uppercase text-primary">
                    Embarazo Actual
                </div>
                <div class="font-weight-bold text-dark d-flex align-items-center flex-wrap">
                    <span class="mr-2">Edad Gestacional:</span>
                    <span class="badge badge-primary px-2 py-1 font-weight-bold shadow-sm" style="font-size: 0.88rem;">
                        <i
                            class="fas fa-heartbeat text-danger mr-1 animate__animated animate__pulse animate__infinite"></i>
                        {{ semanasGestacion }} semanas
                    </span>
                </div>
            </div>
        </div>
        <div class="d-flex align-items-center my-1 flex-wrap">
            <span  class="badge badge-light border text-dark py-1 px-2 mr-2 mb-1">
                <i class="fas fa-calendar-alt text-primary mr-1"></i> FPP: <strong>{{ embarazo_actual.fecha_parto |
                    formatDate }}</strong>
            </span>
            <span v-if="embarazo_actual.ultima_menstruacion" class="badge badge-light border text-dark py-1 px-2 mb-1">
                <i class="far fa-calendar-alt text-secondary mr-1"></i> FUM: <strong>{{
                    embarazo_actual.ultima_menstruacion | formatDate }}</strong>
            </span>
        </div>
    </div>
</template>
<script>
import dayjs from "dayjs";
import embarazoActualService from "../../../../services/embarazoActualService";
import { isEmpty } from "lodash";
export default {
    props: ['embarazo'],
    data() {
        return {
            embarazo_actual: {}
        }
    },
    methods: {
        async cargarEmbarazoActual() {
            if (!isEmpty(this.embarazo) && this.embarazo.id) {
                const response = await embarazoActualService.showByLast(this.embarazo.id);
                if (!isEmpty(response.data)) {
                    this.embarazo_actual = response.data;
                }
            }
        },
    },
    mounted() {
        this.cargarEmbarazoActual();
    },
    computed: {
        semanasGestacion() {
            if (!this.embarazo_actual.ultima_menstruacion) return 0;
            const fechaUltimaMenstruacion = dayjs(this.embarazo_actual.ultima_menstruacion);
            if (!fechaUltimaMenstruacion.isValid()) return 0;
            const fechaActual = dayjs();
            const diasGestacion = fechaActual.diff(fechaUltimaMenstruacion, 'day');
            if (diasGestacion <= 0) return 0;

            const semanas = Math.floor(diasGestacion / 7);
            const diasRestantes = diasGestacion % 7;

            return diasRestantes > 0 ? parseFloat(`${semanas}.${diasRestantes}`) : semanas;
        }
    },
    watch: {
        embarazo: {
            handler: async function () {
                await this.cargarEmbarazoActual();
            },
            deep: true
        }
    }
}   
</script>